import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        page: {
            total: 0,
            records: []
        },
        pageSearch: {
            current: 1,
            size: 10,
            search: {
                status: false,
                menu_id: null,
                like_code: null,
                like_name: null,
            }
        }
    },
    getters: {
        ['MenuPermissionListGetPageSearchSearch'](state) {
            return state.pageSearch.search;
        },
        ['MenuPermissionListGetPageSearch'](state) {
            return state.pageSearch;
        },
        ['MenuPermissionListGetPageCurrent'](state) {
            return state.pageSearch.current;
        },
        ['MenuPermissionListGetPageSize'](state) {
            return state.pageSearch.size;
        },
        ['MenuPermissionListGetPageTotal'](state) {
            return state.page.total;
        },
    },
    mutations: {
        ['MenuPermissionListSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['MenuPermissionListSetPage'](state, page) {
            state.page = page;
        },
        ['MenuPermissionListSetPageSearch'](state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        ['MenuPermissionListSetPageSearchSearch'](state, pageSearchSearch) {
            state.pageSearch.search = pageSearchSearch;
        },
        ['MenuPermissionListSetPageCurrent'](state, pageCurrent) {
            state.pageSearch.current = pageCurrent;
        },
        ['MenuPermissionListSetPageSize'](state, pageSize) {
            state.pageSearch.size = pageSize;
        }
    },
    actions: {
        async queryByPage({commit}, params) {
            commit('MenuPermissionListSetLoading', true);
            commit('MenuPermissionListSetPageSearch', params);
            try {
                let result = await OrganizationServer.menuPermission.page(params);
                if (result.data.code === '200') {
                    commit('MenuPermissionListSetPage', result.data.data);
                }
                commit('MenuPermissionListSetLoading', false);
            } catch (e) {
                console.log(e.message);
                commit('MenuPermissionListSetLoading', false);
                throw e;
            }
        }
    }
}